import * as angular from 'angular';

import { ComponentDefinition } from '../../models';
import { ITagDefinitionService, ILoggerService } from '../../services/';

class UploadFileDialogController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;

    files: any[];
    updating: boolean;
    refresh: () => void;

    private _modal: any; //JQuery
    private _garbages: (() => void)[] = [];

    static $inject = [
    ];

    $onInit() {
        this.files = [];
        this._modal = angular.element('#importCsvMetaDataModal');
    }

    $onDestroy() {
        this._garbages.forEach(g => g());
    }
}

export const wtUploadFileDialog: ComponentDefinition = {
    componentId: 'wtUploadFileDialog',
    controller: UploadFileDialogController,
    template: require('./uploadFileDialog.component.html'),
    controllerAs: 'vm',
    bindings: {
    }
};